import { motion } from "framer-motion";
import { ARTISTS, RELEASES } from "@/data/catalog";
import { usePlayer } from "@/context/PlayerContext";
import { ArrowUpRight } from "lucide-react";

export const Artists = () => {
  const { play } = usePlayer();

  const openArtist = (name) => {
    const track = RELEASES.find((r) => r.artist === name) || RELEASES[0];
    play(track);
  };

  return (
    <section id="roster" data-testid="artists" className="relative bg-void py-24 md:py-32 px-5 md:px-10 border-t border-white/10">
      <div className="max-w-[1600px] mx-auto">
        <div className="mb-14 md:mb-20">
          <p className="font-mono uppercase tracking-[0.3em] text-xs text-signal mb-4">[ The Roster ]</p>
          <h2 className="font-display uppercase leading-[0.85] tracking-tighter text-white text-6xl md:text-8xl">
            The <span className="text-stroke-red">Crew</span>
          </h2>
        </div>

        <div className="border-t border-white/10">
          {ARTISTS.map((a, i) => (
            <motion.button
              key={a.name}
              data-testid={`artist-row-${a.name}`}
              onClick={() => openArtist(a.name)}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.04 }}
              className="group w-full text-left border-b border-white/10 py-6 md:py-8 flex items-center gap-4 md:gap-10 hover:bg-charcoal/60 px-2 md:px-6 transition-colors"
            >
              <span className="font-mono text-xs text-white/30 w-8">0{i + 1}</span>
              <div className="flex-1 min-w-0">
                <h3 className="font-display uppercase tracking-tight text-3xl md:text-6xl text-white/80 group-hover:text-signal transition-colors leading-none truncate">
                  {a.name}
                </h3>
              </div>
              <span className="hidden md:block font-body text-sm text-white/40 max-w-xs truncate">{a.note}</span>
              <span className="font-mono uppercase tracking-[0.2em] text-[10px] text-white/50 whitespace-nowrap">{a.roster}</span>
              <span className="font-mono text-[10px] text-white/40 whitespace-nowrap hidden sm:block">{a.releases} REL.</span>
              <ArrowUpRight size={22} className="text-white/30 group-hover:text-signal group-hover:rotate-12 transition-all shrink-0" />
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
